import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SearchDivisionsParameters } from '@app/services/http/clients/api-proxies';
import { DepartmentService } from '@app/services/http/clients/department.service';
import { DivisionView } from '@app/services/http/clients/reporting-app/reporting-api-proxies';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { createValueAccessorProvider, FormEditorBase } from '../base/form-editor-base';

@Component({
    selector: 'app-department-form-editor',
    templateUrl: './department-form-editor.component.html',
    styleUrl: './department-form-editor.component.scss',
    providers: [createValueAccessorProvider(DepartmentFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class DepartmentFormEditorComponent extends FormEditorBase<DivisionView[]> implements OnInit {
    value = input<DivisionView[]>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select Departments');

    private readonly departmentService = inject(DepartmentService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadDepartments();
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): DivisionView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: DivisionView[]): any[] {
        return value || [];
    }

    private async loadDepartments(): Promise<void> {
        const roles = await this.departmentService.search({ isActive: true } as SearchDivisionsParameters);
        this.items.set(roles);
    }
}
